/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SaveVoxtralCorrectionContextRequest } from '../../models/save-voxtral-correction-context-request';

export interface ApiBroadcastVoxtralCorrectionContextsNamePut$Params {
  name: string;
      body?: SaveVoxtralCorrectionContextRequest
}

export function apiBroadcastVoxtralCorrectionContextsNamePut(http: HttpClient, rootUrl: string, params: ApiBroadcastVoxtralCorrectionContextsNamePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiBroadcastVoxtralCorrectionContextsNamePut.PATH, 'put');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiBroadcastVoxtralCorrectionContextsNamePut.PATH = '/api/Broadcast/voxtral/correction-contexts/{name}';
